export const useConfig = () => {
  return {
    photoLimit: 15,
    fileLimit: 30,
    openAddress: 'https://storage.lensvet-dev.unilight.ru/inventory/',
    downloadAddress: '/inventory/files/',
  }
}
